import React from 'react';
import Carousel from '../../../../components/Carousel';
import Thumb from '../../../../components/Thumb';
import {shuffleArray} from "../../../../../libs/helper";
import {useQuery} from "@tanstack/react-query";
import {
    FEATURE_VIDEOS_KEY,
    fetchHomeMediasVideos
} from "../../../../../api/public-voissa/features";


const VideoHome = () =>{
    const {isSuccess : isSuccessMedias, data : dataMedias} = useQuery(
        [FEATURE_VIDEOS_KEY],
        ()=> fetchHomeMediasVideos(),
        {
            staleTime : (1000 * 60 * 5),
            placeholderData : {
                data : new Array(18).fill({}),
            },
            select : (data) =>{
                let medias = data.data || [];
                return shuffleArray(medias, 30);
            }
        }
    );

    return (
        <Carousel>
            <div className="pane">
                <div className="row">
                    {isSuccessMedias && dataMedias.slice(0, 5).map((video, index) => (
                        <Thumb
                            key={index}
                            media={video}
                            cropTitle={45}
                        />
                    ))}
                </div>
                <div className="row">
                    {isSuccessMedias && dataMedias.slice(5, 10).map((video, index) => (
                        <Thumb
                            key={index}
                            media={video}
                            cropTitle={45}
                        />
                    ))}
                </div>
            </div>
            <div className="pane">
                <div className="row">
                    {isSuccessMedias && dataMedias.slice(10, 15).map((video, index) => (
                        <Thumb
                            key={index}
                            media={video}
                            cropTitle={45}
                        />
                    ))}
                </div>
                <div className="row">
                    {isSuccessMedias && dataMedias.slice(15, 20).map((video, index) => (
                        <Thumb
                            key={index}
                            media={video}
                            cropTitle={45}
                        />
                    ))}
                </div>
            </div>
            <div className="pane">
                <div className="row">
                    {isSuccessMedias && dataMedias.slice(20, 25).map((video, index) => (
                        <Thumb
                            key={index}
                            media={video}
                            cropTitle={45}
                        />
                    ))}
                </div>
                <div className="row">
                    {isSuccessMedias && dataMedias.slice(25, 30).map((video, index) => (
                        <Thumb
                            key={index}
                            media={video}
                            cropTitle={45}
                        />
                    ))}
                </div>
            </div>
        </Carousel>
    )
};

export default VideoHome;